<template>
  <div class="mainfooter _mainfooter">
    <img src="../../assets/imgs/map_img.png"/>
    <div class="mapicon chinamap">
      <!--      <img v-if="$i18n.locale=='zh_HK'" @click="goMapHK" style="width: 1.8em" src="../../assets/imgs/mapicon/HongKong.png"-->
      <!--      :title="getaddressHtml($t('header.HongKong'))"/>-->
      <!--      <img v-else @click="goMapHK" src="../../assets/imgs/mapicon/hk_eng.png" style="width: 4.3em"-->
      <!--           :title="getaddressHtml($t('header.HongKong'))"/>-->
      <div class="icombox" @click="goMapHK">
        <img  src="../../assets/imgs/map_icon.png"
             :title="getaddressHtml($t('header.HongKong'))"/>
        <p >{{$t('header.HongKong')}}</p>
      </div>

    </div>
    <div class="mapicon xianmap">
      <div class="icombox" @click="goMapXA">
        <img  src="../../assets/imgs/map_icon.png"
             :title="getaddressHtml($t('header.XiAn'))"/>
        <p >{{$t('header.XiAn')}}</p>
      </div>

    </div>
    <div class="mapicon shanghaimap">
      <div class="icombox" @click="goMapSH">
        <img  src="../../assets/imgs/map_icon.png"
             :title="getaddressHtml($t('header.Shanghai'))"/>
        <p >{{$t('header.Shanghai')}}</p>
      </div>
    </div>
    <div class="bottomdiv">
      <div v-show="type==1">
        <button class="button " @click="$router.push('/contacts')">{{$t('header.Contact')}}</button>
      </div>
      <h1 v-show="type!=1">{{$t('header.Contact')}}</h1>

      <div class="bodybottom">
        <div>
          <h1 v-html="$i18n.locale=='zh_HK'?name[0]:nameEn[0]">{{$i18n.locale=='zh_HK'?name[0]:nameEn[0]}}
          </h1>
          <span>
            <p
              v-html="$i18n.locale=='zh_HK'?address[0]:addressEn[0]">{{$i18n.locale=='zh_HK'?address[0]:addressEn[0]}}</p>
            <p>{{$t('header.Email')}}：{{email[0]}}</p>
            <p>{{$t('header.Telno')}}：{{phone[0]}}</p>
            </span>
        </div>
        <div>
          <h1 v-html="$i18n.locale=='zh_HK'?name[1]:nameEn[1]">{{$i18n.locale=='zh_HK'?name[1]:nameEn[1]}}
          </h1>
          <span>
            <p
              v-html="$i18n.locale=='zh_HK'?address[1]:addressEn[1]">{{$i18n.locale=='zh_HK'?address[1]:addressEn[1]}}</p>
            <p>{{$t('header.Email')}}：{{email[1]}}</p>
            <p>{{$t('header.Telno')}}：{{phone[1]}}</p>
            </span>
        </div>
        <div>
          <h1 v-html="$i18n.locale=='zh_HK'?name[2]:nameEn[2]">{{$i18n.locale=='zh_HK'?name[2]:nameEn[2]}}
          </h1>
          <span>
            <p
              v-html="$i18n.locale=='zh_HK'?address[2]:addressEn[2]">{{$i18n.locale=='zh_HK'?address[2]:addressEn[2]}}</p>
            <p>{{$t('header.Email')}}：{{email[2]}}</p>
            <p>{{$t('header.Telno')}}：{{phone[2]}}</p>
            </span>
        </div>
      </div>

    </div>
    <div class="footerbottom _footerbottom">
      <p>{{$t('header.banq')}}
      </p>
    </div>

  </div>
</template>

<script>
  import {getContactsMeList} from '@/api/home'

  export default {
    name: 'Mapposition',
    components: {},
    props: ['type'],
    data () {
      return {
        list: '',
        name: [],
        nameEn: [],
        address: [],
        addressEn: [],
        email: [],
        phone: [],
        positioning: [],
        // LocationHK: "香港办事处地点",
        // locationXA:'中国陕西省西安市阎良区航空一路38号',
        // locationXA:'中国陕西省西安市阎良区航空一路38号',
        // locationSH:'上海市嘉定区丰功路55弄6号',
      }
    },
    created () {
      this.getContactsMeList()
    },
    methods: {
      getContactsMeList () {
        getContactsMeList().then(response => {
          const data = response.data
          this.list = data.data
          // console.log(this.list)
          this.list.forEach((item, index) => {
            this.positioning.push(item.positioning)
            this.name.push(item.name)
            this.nameEn.push(item.nameEn)
            this.address.push(item.address)
            this.addressEn.push(item.addressEn)
            this.email.push(item.email)
            this.phone.push(item.phone)
          })
        })
      },
      getimgsrc (imgvalue) {
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, '')
        return process.env.BASE_IMG + imgs
      },
      goMapHK () {
        // window.location.href = "https://www.google.com.hk/maps/search/" + this.LocationHK;
        window.location.href = 'https://www.google.com.hk/maps/search/' + this.positioning[0]
      },
      goMapXA () {
        var varlocat = this.address[1].replace(/<[^<>]+?>/g, '')
        var location = varlocat.split(',')
        window.location.href = 'http://api.map.baidu.com/direction?origin=latlng:12363856.501521153,4458391.644999983|name:北京市&destination=' + location[0] + '&mode=driving&region=中国&output=html&src=webapp.baidu.openAPIdemo'
        // window.location.href = 'http://api.map.baidu.com/direction?origin=latlng:' + location[0] + '&output=html&src=我的位置'
        // window.location.href = 'http://api.map.baidu.com/geocoder?address=' + location[0] + '&output=html&src=我的位置'
        // window.location.href = "https://www.google.com.hk/maps/search/" + this.Location ;
        // window.location.href = "https://www.google.com.hk/maps/place/" + this.positioning[1];
      },
      goMapSH () {
        var varlocat = this.address[2].replace(/<[^<>]+?>/g, '')
        var location = varlocat.split(',')
        console.log(location[0])
        console.log('中国上海市嘉定区丰功路55弄景鑫工业园区6号')
        window.location.href = 'http://api.map.baidu.com/direction?origin=latlng:12363856.501521153,4458391.644999983|name:北京市&destination=' + location[0] + '&mode=driving&region=中国&output=html&src=webapp.baidu.openAPIdemo'
        // window.location.href = 'http://api.map.baidu.com/geocoder?address=' + location[0] + '&output=html&src=我的位置'
        // window.location.href = "https://www.google.com.hk/maps/search/" + this.positioning[2];
        // window.location.href = "https://www.google.com.hk/maps/place/"+this.locationSH;
      },
      getaddressHtml (value) {
        if (value != null || value != undefined) {
          var htmltext = value.replace(/<[^<>]+?>/g, '')
        }
        return htmltext//删除所有HTML标签
      },
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .mainfooter {
      position: relative;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: #0F2538;
      color: white;
      overflow: hidden;

      img {
        width: 100%;
        height: auto;
      }

      .mapicon {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        /*width: 90%;*/
        /*max-width: 1500px;*/
        display: flex;
        flex-direction: column;
        align-items: center;

        .icombox {
          transition: all 0.1s; //设置动画执行的时间为0.6s
          cursor: pointer;

          img {
            width: 2em;
            height: 60%;
          }

          p {
            color: red;
            font-size: 1.2em;
            font-weight: bold;
          }
        }

        .icombox:hover {
          transform: scale(1.2);
        }
      }

      .chinamap {
        margin-top: 27.9%;
        margin-left: 10%;
      }

      .xianmap {
        margin-top: 20.5%;
        margin-left: 4.5%;
      }

      .shanghaimap {
        margin-top: 20.2%;
        margin-left: 12.5%;
      }

      .bottomdiv {
        position: absolute;
        top: 4%;
        /*margin-top: -52%;*/
        width: 90%;
        left: 50%;
        transform: translateX(-50%);
        /*left: 5%;*/
        max-width: 1600px;
        display: flex;
        align-items: center;
        flex-direction: column;
        align-items: center;
        margin-bottom: 4%;

        h1 {
          font-size: 3em;
          position: relative;
        }

        .button {
          background: rgba(0, 0, 0, 0);
          border: 1.5px solid white;
          color: white;
          padding: 5% 2vw;
          text-align: center;
          text-decoration: none;
          display: inline-block;
          font-weight: bold;
          font-size: 2em;
          transition: all 0.4s; //设置动画执行的时间为0.6s
          cursor: pointer;
        }

        .button:hover {
          transform: scale(0.9);
        }

        .bodybottom {
          position: absolute;
          bottom: -44vw;
          /*margin-top: 24vw;*/
          display: flex;
          align-items: flex-start;
          width: 100%;
          justify-content: space-around;

          div {
            padding: 1em 1em;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            /*background-color: #eeeeee;*/
            text-align: left;
            /*line-height: 35px;*/
            line-height: 1.7em;

            h1 {
              font-size: 1.2em;
              padding-top: 10px;

            }

            a {
              img {
                width: 10%;
                height: 60%;
              }

            }

            h1:hover {
              /*transform: scale(1.05);*/
            }

            span {
              font-size: 1em;
              color: white;

              p {
                padding: 0.4em 0;
              }
            }

            div {

              /*height: 45vh;*/
              /*width: 30vw;*/
              width: 100%;
              height: 50%;
              position: relative;

              img {
                padding: 0px 0.5%;
                position: absolute;
                /*height: 100%;*/
                width: 100%;
                bottom: 0;
              }
            }
          }
        }
      }

      .footerbottom {
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
        /*margin-top: 10%;*/
        padding: 20px 0;
        bottom: 0;

        p {
          font-size: 0.9em;

        }
      }


    }

  }

  @media only screen and (max-width: 800px) {
    ._mainfooter {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      background: #0F2538;
      align-items: center;
      color: white;
      font-size: 1em;
      overflow: hidden;

      img {
        width: 180%;
        height: auto;
        /*margin-bottom: %;*/
      }

      .mapicon {
        position: absolute;
        /*width: 90%;*/
        /*max-width: 1500px;*/
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 4em;
          height: 60%;
          transition: all 0.2s; //设置动画执行的时间为0.6s
          cursor: pointer;
        }
        p {
          color: red;
          font-size: 1.3em;
          font-weight: bold;
        }
      }

      .chinamap {
        margin-top: 48%;
        margin-left: 18%;
      }

      .xianmap {
        margin-top: 35.9%;
        margin-left: 8%;
      }

      .shanghaimap {
        margin-top: 35%;
        margin-left: 23%;
      }

      .bottomdiv {
        position: absolute;
        margin-top: 6%;

        width: 98%;
        flex-direction: column;
        align-items: center;
        margin-bottom: 4%;

        h1 {
          margin-top: 6%;
          font-size: 1.2em;
        }

        .button {
          background: rgba(0, 0, 0, 0);
          border: 1.5px solid white;
          color: white;
          padding: 2% 2vw;
          text-align: center;
          text-decoration: none;
          display: inline-block;
          font-weight: bold;
          font-size: 2em;
        }

        .bodybottom {
          position: absolute;
          bottom: -80vw;
          /*margin-top: 8%;*/
          width: 100%;
          left: 1%;
          display: flex;
          justify-content: center;

          div {

            /*padding-bottom: 5px;*/
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            /*width: 380px;*/
            font-size: 1em;
            text-align: left;
            line-height: 1.5em;

            h1 {
              padding-top: 5px;
              font-size: 1.3em;
              font-weight: normal;
            }

            a {
              img {
                width: 15%;
                height: 90%;
              }

            }

            span {
              font-size: 1.2em;
              color: white;
              padding-bottom: 1em;
              padding-right: 5px;

              p {
                padding: 0.4em 0;
              }
            }
          }
        }
      }

      .footerbottom {
        position: absolute;
        padding: 5px 0;
        bottom: 0;

        p {
          font-size: 1em;

        }
      }


    }
  }

</style>



// WEBPACK FOOTER //
// src/views/comcomponents/Mapposition.vue